
<div class="flex-row-reverse flex--align-center full-width">

    <button [disabled]="noMenuActionsSubject | async" color="primary"  mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" >    
        <mat-icon>more_vert</mat-icon>
    </button>

    <ng-container *ngIf="canSignSubject | async">

        <button *ngIf="isSmallerScreenObs | async;else standardButton"  mat-icon-button color="primary" (click)="sign();$event.stopPropagation()">

            <mat-icon>draw</mat-icon>
        </button>
    
        <ng-template #standardButton>
            <button   mat-button color="primary" class="light-bold" (click)="sign();$event.stopPropagation()">
    
                <mat-icon>draw</mat-icon>{{'ss-actions.sign' | translate}}
            </button>
        </ng-template>
    </ng-container>
    
    
</div>

<mat-menu  #menu xPosition="before" >

    <button *ngIf="canCancelSubject | async"   mat-menu-item class="error-text full-width min-height-none padding-small gap-small"   (click)="cancel()">
        <mat-icon class="margin-none">cancel</mat-icon>
        <span class="light-bold">{{'ss-entities.process.actions.cancel.display' | translate}}</span>
    </button>

    <button *ngIf="canRejectSubject | async"  mat-menu-item   class="error-text full-width min-height-none padding-small gap-small"   (click)="reject()">
        <mat-icon class="margin-none">warning</mat-icon>
        <span class="light-bold">{{'ss-actions.reject' | translate}}</span>
    </button>
    
    <button *ngIf="canDeleteSubject | async"  mat-menu-item   class="error-text full-width min-height-none padding-small gap-small"    (click)="deleteProcess()">
        <mat-icon class="margin-none">delete</mat-icon>
        <span class="light-bold">{{'ss-actions.delete' | translate}}</span>
    </button>
    
    <button *ngIf="canDownloadSubject | async"  mat-menu-item class="primary-text full-width min-height-none padding-small gap-small" (click)="downloadDocuments()">
        <mat-icon class="margin-none">download</mat-icon>
        <span class="light-bold">{{'ss-entities.process.actions.document-download.display' | translate}}</span>
    </button>

    <button *ngIf="canDownloadAuditTrailSubject | async"  mat-menu-item class="primary-text full-width min-height-none padding-small gap-small" (click)="downloadAuditTrail()">
        <mat-icon class="margin-none">download</mat-icon>
        <span class="light-bold">{{'ss-entities.process.actions.audit-trail.display' | translate}}</span>
    </button>

    <button *ngIf="canRestartSubject | async"  mat-menu-item class="primary-text full-width min-height-none padding-small gap-small" (click)="restart()">
        <mat-icon class="margin-none">refresh</mat-icon>
        <span class="light-bold">{{'ss-entities.process.actions.restart.display' | translate}}</span>
    </button>

    <button *ngIf="canChangeValidTillSubject | async"  mat-menu-item class="primary-text full-width min-height-none padding-small gap-small" (click)="changeValidTill()">
        <mat-icon class="margin-none">edit_calendar</mat-icon>
        <span class="light-bold">{{'ss-entities.process.actions.change-valid-till.display' | translate}}</span>
    </button>

</mat-menu> 